<template>
  <div v-if="show" ref="chart" class="chart-content">
    <div class="chart-title">{{name}}</div>
    <i v-if="isShowCloseBtn" class="iconfont icon-guanbi_o chart-close" @click='close($event)' :class="{active: name !== ''}"></i>
    <!-- :style='changeStyle'-->
    <div class='box-list' :style="{height:boxListHeight}">
      <div class="box">
        <span>近6个月到期</span><br />
        <span class="box-value">数量 <span class="box-name">{{form.sixMonthStockCount}} </span></span><br />
        <span class="box-name">{{form.sixMonthStockAmount}} <span class="box-value"> 万元</span></span>
      </div>
      <div class="box" style="line-height:30px">
        <span>本月待验收单量</span><br />
        <span class="box-value">普通&nbsp;&nbsp;<span class="box-name">{{form.purchaseNotCheckCount}}</span></span><br />
        <span class="box-value">备货&nbsp;&nbsp;<span class="box-name">{{form.stockUpNotCheckCount}}</span></span><br />
        <span class="box-value">跟台&nbsp;&nbsp;<span class="box-name">{{form.surgicalNotCheckCount}}</span></span>
      </div>
      <div class="box" style="line-height:30px">
        <span>本月已验收单量</span><br />
        <span class="box-value">普通&nbsp;&nbsp;<span class="box-name">{{form.purchaseCheckCount}}</span></span><br />
        <span class="box-value">备货&nbsp;&nbsp;<span class="box-name">{{form.stockUpCheckCount}}</span></span><br />
        <span class="box-value">跟台&nbsp;&nbsp;<span class="box-name">{{form.surgicalCheckCount}}</span></span>
      </div>
      <div class="box">
        <span>已过期库存</span><br />
        <span class="box-value">数量 <span class="box-name">{{form.overdueCount}} </span></span><br />
        <span class="box-name">{{form.overdueAmount}} <span class="box-value"> 万元</span></span>
      </div>
    </div>
  </div>
</template>


<script>
import elementResizeDetectorMaker from "element-resize-detector";
import {
  StockOverview
} from '@/api'
import BaseReportMixin from '@/mixin/baseReport-mixin.js'
import { EleResize } from '@/utils/EleResize.js'
export default ({
  mixins: [BaseReportMixin],
  data () {
    return {
      myChart: null,
      option: {},
      tableData: [],
      allData: [],
      show: true,
      totalPage: 0,
      pageSize: 5,
      pageIndex: 1,
      interval: 5000 * 1000,
      setInterval: null,
      form: {},
      boxListHeight: ''
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    getDataAction: {
      type: Function,
      default () {
        return null
      }
    },
    tableColumns: {
      type: Array,
      default () {
        return []
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    },
  },
  methods: {
    // 获取列表
    getData () {
      StockOverview({})
        .then(res => {
          this.form = res.returnData
          // this.allData = res.returnData
          // this.totalPage = Math.ceil(this.allData.length / this.pageSize)
          // this.tableData = this.getPaginationData(this.allData, this.pageIndex, this.pageSize)
          // console.log(this.data)
          // this.myChart.setOption(this.option);
          // this.init(res.returnData)
        })
    },
    changeStyle () {
      if (this.name == '') {
        return { 'margin-top': -19 + 'px' };
      }
      else {
        return { 'margin-top': 0 + 'px' };
      }
    },
    // getPaginationData (list, pageIndex, pageSize) {
    //   return list ? list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize) : []
    // },
    init () {
      // this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      // const _this = this
      // let erd = elementResizeDetectorMaker();
      // erd.listenTo(this.$refs.myChart, (e) => {
      //   _this.$nextTick(() => {
      //     // _this.myChart.resize();

      //   })
      // })
      EleResize.on(this.$refs['chart'], (e) => {
        // console.log(e.target.innerHeight, 'e')
        // console.log(this.$refs['chart'].parentNode, 'this.$refs')
        this.$emit('SizeChange', e.target.innerWidth, e.target.innerHeight, this.$refs['chart'].parentNode.id)
      })
    },
    close (e) {
      this.show = false
      clearInterval(this.setInterval)
      // 给drag+index div 追加隐藏样式 e.path[2] = drag2 非动态获取
      e.target.parentNode.parentNode.classList.add('hide')
      //修改state=0
      this.$emit('StateChange', 0, e.target.parentNode.parentNode.id);
    }
  },
  mounted () {
    this.getData();
    this.init()
    let that = this
    this.setInterval = setInterval(function () {
      that.pageIndex++;
      if (that.pageIndex > that.totalPage) {
        that.pageIndex = 1
        that.getData()
      }
      else {
        that.tableData = that.getPaginationData(that.allData, that.pageIndex, that.pageSize)
      }
    }, this.interval)
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    console.log(this.name, 'name')
    if (this.isShowCloseBtn) {
      this.boxListHeight = 'calc(100% - 25px)'
    }
    else {
      this.boxListHeight = '100%'
    }
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: calc(100% - 20px);
  height: 100%;
  padding: 0 10px 10px;
  // display: flex;
  .chart {
    width: 100%;
    height: 100%;
    // position: absolute;
  }
  .chart-title {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  .chart-close {
    height: 20px;
    width: 20px;
    color: rgb(255, 255, 255);
    margin-left: 20px;
    float: right;
    // margin-top: -19px;
    &.active {
      margin-top: -19px;
    }
  }
  .box-list {
    display: inline-flex; //-webkit-inline-box;;
    width: 100%;
    height: 100%;
    padding: 10px 0;
  }
  .box {
    width: 25%; //21.7%;
    height: calc(100% - 40px);
    border: 2px #063692 solid;
    background-color: #0a195a;
    padding: 10px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    margin: 0 10px;
  }
  .box-value {
    color: #1b6f8b;
    font-weight: bold;
  }
  .box-name {
    color: #d5dd2d;
    font-weight: bold;
  }
}

/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  background-color: transparent !important;
}
::v-deep .el-table__header-wrapper {
  margin-bottom: 0px !important;
}

/deep/ .el-table tbody tr {
  pointer-events: none;
}
</style>
